import { channelPartnerKeyScopeKey as e } from "./channelPartnerKeyScopeKey.mjs";
import { useTrEnumNamespace as t } from "./useTrEnumNamespace.mjs";
import { useCallback as n } from "react";
//#region src/enums/useTrChannelPartnerKeyScope.ts
var r = () => {
	let r = t("channelPartnerKeyScope");
	return n((t) => {
		let n = e(t), i = r(n);
		return i === n ? t : i;
	}, [r]);
};
//#endregion
export { r as useTrChannelPartnerKeyScope };
